import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { AppHeader } from './AppHeader';
import { StandaloneHeader } from './StandaloneHeader';
import { PageTransition } from '../ui/PageTransition';
import { useTicketsRealtime } from '../../hooks/useTicketsRealtime';
import { useTasksRealtime } from '../../hooks/useTasksRealtime';
import { GlobalTaskModal } from '../tasks/GlobalTaskModal';
import { MessagingSidecar } from '../messaging/sidecar/MessagingSidecar';
import { PresenceBroadcast } from '../system/PresenceBroadcast';
// Bulle Nova IA masquée temporairement (positionnement à revoir) — voir plus bas.
// import { NovaLauncherButton } from '../assistant/NovaLauncherButton';
import { NovaModal } from '../assistant/NovaModal';
import { useUnreadDocumentTitle } from '../../hooks/useUnreadDocumentTitle';
import { QuickCreateHost } from '../quickCreate/QuickCreateHost';
import { useQuickCreateTiles } from '../quickCreate/useQuickCreateTiles';
import type { QuickCreateKind } from '../../lib/quickCreate';
import { useStandaloneChrome } from '../../hooks/useStandaloneChrome';
import { useAppDateFormat } from '../../hooks/useAppDateFormat';

function TicketsRealtimeMounter() {
  useTicketsRealtime();
  return null;
}

function UnreadDocumentTitleMounter() {
  useUnreadDocumentTitle();
  return null;
}

function TasksRealtimeMounter() {
  useTasksRealtime();
  return null;
}

export function MainLayout() {
  const standalone = useStandaloneChrome();
  if (standalone) return <StandaloneShell />;
  return <CabinetShell />;
}

function StandaloneShell() {
  const location = useLocation();
  const dateFormat = useAppDateFormat();
  return (
    <div className="flex h-screen overflow-hidden bg-cime-bg">
      <TasksRealtimeMounter />
      <UnreadDocumentTitleMounter />
      <PresenceBroadcast />
      <div className="flex-1 flex flex-col min-w-0 min-h-0">
        <StandaloneHeader />
        <main className="flex-1 min-h-0 overflow-hidden">
          <PageTransition key={`${location.pathname.split('/')[1] ?? '/'}:${dateFormat}`}>
            <Outlet />
          </PageTransition>
        </main>
      </div>
      <GlobalTaskModal />
    </div>
  );
}

function CabinetShell() {
  const location = useLocation();
  const dateFormat = useAppDateFormat();
  const [quickOpen, setQuickOpen] = useState(false);
  const [quickFollowUp, setQuickFollowUp] = useState<QuickCreateKind | null>(null);
  const quickTiles = useQuickCreateTiles();

  return (
    <div className="flex h-screen overflow-hidden bg-cime-bg">
      <TicketsRealtimeMounter />
      <TasksRealtimeMounter />
      <UnreadDocumentTitleMounter />
      <PresenceBroadcast />
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 min-h-0">
        <AppHeader
          onOpenCreate={
            quickTiles.length > 0
              ? () => {
                  setQuickFollowUp(null);
                  setQuickOpen(true);
                }
              : undefined
          }
        />
        <main className="flex-1 min-h-0 overflow-hidden">
          <PageTransition key={`${location.pathname.split('/')[1] ?? '/'}:${dateFormat}`}>
            <Outlet />
          </PageTransition>
        </main>
      </div>
      <GlobalTaskModal />
      <QuickCreateHost
        tiles={quickTiles}
        open={quickOpen}
        onOpenChange={setQuickOpen}
        followUp={quickFollowUp}
        onFollowUp={setQuickFollowUp}
      />
      <MessagingSidecar />
      {/* <NovaLauncherButton /> — masquée temporairement, positionnement à revoir */}
      <NovaModal />
    </div>
  );
}
